import { Grid } from "@material-ui/core";
import {
  FunctionField,
  Labeled,
  ReferenceField,
  TextField,
  useRecordContext,
} from "react-admin";
import CustomDateField from "./CustomDateField";

const OwnershipField = () => {
  const record = useRecordContext();
  return (
    <>
      <Grid item xs={3}>
        <Labeled source="Ownership">
          <FunctionField
            render={() =>
              record.subcontractorId === 1 ? "WTS" : "Subcontractor"
            }
          />
        </Labeled>
      </Grid>
      <Grid item xs={9}></Grid>

      {record.subcontractorId !== 1 && (
        <>
          <Grid item xs={3}>
            <Labeled source="Subcontractor">
              <ReferenceField
                source="subcontractorId"
                reference="subcontractors"
                emptyText="-"
                linkType="show"
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid item xs={9}></Grid>
        </>
      )}

      {record.subcontractorId === 1 && (
        <>
          <Grid item xs={3}>
            <Labeled source="Employee Code">
              <TextField source="employeeCode" emptyText="-" />
            </Labeled>
          </Grid>
          <Grid item xs={9}></Grid>

          <Grid item xs={3}>
            <Labeled source="Commencement Date">
              <CustomDateField source="commencementDate" />
            </Labeled>
          </Grid>
          <Grid item xs={3}>
            <Labeled source="Resignation Date">
              <CustomDateField source="resignationDate" />
            </Labeled>
          </Grid>
          <Grid item xs={6}></Grid>
        </>
      )}
    </>
  );
};

export default OwnershipField;
